import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { EMPTY, Observable, of } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { RequestTrackerService } from '../request-tracker-service.service';


@Injectable()
export class RequestLockInterceptor implements HttpInterceptor {
  private isLocked = false;

  constructor(private tracker: RequestTrackerService) {}

private requestCache = new Set<string>();

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  const method = req.method.toUpperCase();

  if (['POST', 'PUT', 'DELETE'].includes(method)) {
    const requestKey = `${req.method}:${req.urlWithParams}:${JSON.stringify(req.body)}`;

    if (this.requestCache.has(requestKey)) {
      console.warn('Duplicate request blocked:', requestKey);
      return EMPTY; // don't send again
    }

    this.requestCache.add(requestKey);
    this.tracker.show();

    return next.handle(req).pipe(
      finalize(() => {
        this.requestCache.delete(requestKey);
        this.tracker.hide();
      })
    );
  }

  return next.handle(req);
}
}